export default __webpack_public_path__ + "static/media/SNAPix_Y_image_warning.df7de59d.jpg";